import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { IMainIndicatorsFilter } from 'pages/Main/components/Filter';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { IBoeingLine } from '@entities/boeing/IBoeingLine';
import { buildDateParams } from '@app/utils/buildDateParams';

export const fetch = async (filters: IMainIndicatorsFilter): Promise<IBoeingLine[]> => {
  const params = buildDateParams(filters);

  const response = await api.get<{
    data: { hashrate_increased: string; date: string }[];
  }>(`${BI_BASE_URL}/boeing/line/increased/hashrate`, {
    params: {
      manager_ids: filters.managers,
      region: filters.regions,
      tag: filters.tags,
      source: filters.sources,
      coins: filters.coins,
      ...params,
    },
  });

  const data = response.data ?? [];

  // @ts-ignore
  return data.map((item: { hashrate_increased: string; date: string }) => ({
    value: item.hashrate_increased,
    date: item.date,
  }));
};

export const useBoeingLineIncreasedHashRate = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
